(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name quote.directive:oqsSection
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="quote">
   <file name="index.html">
   <oqs-section></oqs-section>
   </file>
   </example>
   *
   */
  angular
    .module('quote')
    .directive('oqsSection', oqsSection);

  function oqsSection() {
    return {
      restrict: 'EA',
      scope: {
        section: '=oqsSectionModel',
        validationActive: '=oqsValidationActive'
      },
      templateUrl: 'quote/directives/oqs-section-directive.tpl.html',
      replace: false,
      controllerAs: 'oqsSection',
      bindToController: true,
      controller: SectionController,
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }

  SectionController.$inject = ['$log', '_', 'DataService'];

  function SectionController($log, _, dataService) {
    var vm = this;
    vm.name = 'oqsSection';
    vm.hidden = false;
    vm.activeInstance = 0;
    vm.tabs = [];
    vm.isSectionAllowed = isSectionAllowed;
    vm.addSectionInstance = addSectionInstance;
    vm.removeSectionInstance = removeSectionInstance;
    vm.isSectionInstanceValid = isSectionInstanceValid;
    vm.truncateString = dataService.truncateString;

    activate();

    function activate() {
      vm.hidden = vm.section.definition.attributes.hidden;
      _.forEach(vm.section.instanceList, function () {
        vm.tabs.push({active: false});
      });
      vm.tabs[0].active = true;
    }

    function addSectionInstance() {
      $log.debug('Adding a section instance.');
      dataService.addSectionInstance(vm.section);
      vm.tabs.push({active: true});
    }

    function removeSectionInstance(index) {
      var activeTabIndex = _.findIndex(vm.tabs, function (tab) {
        return tab.active;
      });
      if (activeTabIndex >= index) {
        vm.tabs[activeTabIndex].active = false;
        if (index > 0) {
          vm.tabs[activeTabIndex - 1].active = true;
        } else {
          vm.tabs[1].active = true;
        }
      }
      _.pullAt(vm.section.instanceList, index);
      _.pullAt(vm.tabs, index);
    }

    function isSectionAllowed() {
      if (angular.isDefined(vm.section.definition.attributes.repeatMax)) {
        return vm.tabs.length < parseInt(vm.section.definition.attributes.repeatMax, 10);
      }
      return true;
    }

    function isSectionInstanceValid(index) {
      var instance = vm.section.instanceList[index];
      return _.every(instance.questionList, function (question) {
        if (!question.hidden && question.definition.attributes.required === 'true' &&
          (angular.isUndefined(question.answer) || question.answer === null)) {
          return false;
        }
        return true;
      });
    }
  }
}());
